// components/personal/Circa.js
import React, { useContext } from 'react';
import './Circa.css';
import Footer from '../components/Footer';
import { LanguageContext } from '../translations/LanguageContext';

function Circa() {
  const { language, translations } = useContext(LanguageContext);
  const t = translations[language].circaPage;

  return (
    <div className="circa-page">
      {/* 1. Hero Section - Restored */}
      <header
        className="circa-hero"
        style={{
          backgroundImage: 'url("/Circa/BG.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center 50px',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="circa-hero-content">
          {/* Use dangerouslySetInnerHTML to allow <br /> in translations */}
          <h1 dangerouslySetInnerHTML={{ __html: t.heroTitle }} />
          <img 
            src="/Circa/new/hero-qr.png" 
            alt="Download QR Code" 
            className="circa-hero-qr"
          />
        </div>
        <img
          src="/Circa/new/hero-mockup.png"
          alt="Circa Phone Mockup"
          className="circa-phone-mockup"
        />
      </header>

      {/* 3. Intro Section */}
      <section className="circa-intro-section">
        <div className="circa-intro-left">
          <h1 className="circa-logo-text">CIRCA</h1>
          <div className="circa-intro-text">
            {t.summaryTexts && t.summaryTexts.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        </div>
        <div className="circa-intro-right">
          {/* Replaced Tilted Cards with Image */}
          <img 
            src="/Circa/new/circa-cards.png" 
            alt="Circa Feature Cards" 
            className="circa-intro-cards-img"
          />
        </div>
      </section>

      {/* 4. User Flow Section */}
      <section className="circa-user-flow-section">
        <div className="circa-flow-header">
           <h2>{t.userFlowTitle}</h2>
           <div className="circa-flow-desc">
             <p>{t.userFlowDesc}</p>
           </div>
        </div>
        
        <div className="circa-flow-scroll-wrapper">
          <div className="circa-flow-diagram-container">
             <svg className="flow-svg" viewBox="0 0 1000 400">
                <defs>
                  <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
                    <polygon points="0 0, 10 3.5, 0 7" fill="#2D4A7F" />
                  </marker>
                </defs>
                
                {/* Lines */}
                {/* Home to Settings (Up) */}
                <line x1="150" y1="170" x2="150" y2="130" stroke="#2D4A7F" strokeWidth="2" />
                {/* Home to Language (Down) */}
                <line x1="150" y1="230" x2="150" y2="270" stroke="#2D4A7F" strokeWidth="2" />
                
                {/* Home to Col 2 */}
                {/* To Player Count */}
                <path d="M220 200 C 270 200, 270 100, 330 100" fill="none" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />
                {/* To Timer */}
                <path d="M220 200 L 320 200" fill="none" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />
                {/* To Categories */}
                <path d="M220 200 C 270 200, 270 300, 330 300" fill="none" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />

                {/* Col 2 to Player Cards */}
                {/* From Player Count */}
                <path d="M470 100 C 530 100, 530 200, 580 200" fill="none" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />
                {/* From Timer */}
                <path d="M470 200 L 570 200" fill="none" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />
                {/* From Categories */}
                <path d="M470 300 C 530 300, 530 200, 580 200" fill="none" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />

                {/* Player Cards to Winner */}
                <line x1="720" y1="200" x2="790" y2="200" stroke="#2D4A7F" strokeWidth="2" markerEnd="url(#arrowhead)" />
             </svg>

             {/* Nodes */}
             <div className="flow-node-item" style={{left: '150px', top: '100px'}}>{t.flowNodes?.settings}</div>
             <div className="flow-node-item" style={{left: '150px', top: '200px'}}>{t.flowNodes?.home}</div>
             <div className="flow-node-item" style={{left: '150px', top: '300px'}}>{t.flowNodes?.language}</div>

             <div className="flow-node-item" style={{left: '400px', top: '100px'}}>{t.flowNodes?.playerCount}</div>
             <div className="flow-node-item" style={{left: '400px', top: '200px'}}>{t.flowNodes?.timer}</div>
             <div className="flow-node-item" style={{left: '400px', top: '300px'}}>{t.flowNodes?.categories}</div>

             <div className="flow-node-item" style={{left: '650px', top: '200px'}}>{t.flowNodes?.playerCards}</div>
             
             <div className="flow-node-item" style={{left: '900px', top: '200px'}}>{t.flowNodes?.winner}</div>
          </div>
        </div>
      </section>

      {/* 5. Typography & Colors */}
      <section className="circa-typo-section">
        <h2>{t.typoTitle}</h2>
        <div className="circa-typo-container">
          <div className="typo-card-top">
            <span className="font-name">{t.fontName}</span>
            <div className="font-samples">
               <span className="sample-22">{t.bodyText} 22</span>
               <span className="sample-20">{t.bodyText} 20</span>
               <span className="sample-18">{t.bodyText} 18</span>
               <span className="sample-12">{t.bodyText} 12</span>
            </div>
          </div>
          <div className="color-palette-row">
             <div className="swatch" style={{backgroundColor: '#AAD489'}}>#AAD489</div>
             <div className="swatch" style={{backgroundColor: '#CBF4AC'}}>
                <span>#CBF4AC</span>
                <span className="swatch-sub">#BBD29E</span>
             </div>
             <div className="swatch" style={{backgroundColor: '#CBF4AC'}}>#CBF4AC</div>
             <div className="swatch" style={{backgroundColor: '#FFFFFF', color: '#232323'}}>#FFFFFF</div>
             <div className="swatch" style={{backgroundColor: '#F43B67'}}>#F43B67</div>
             <div className="swatch" style={{backgroundColor: '#0D2755'}}>#0D2755</div>
             <div className="swatch" style={{backgroundColor: '#1D3C74'}}>#1D3C74</div>
             <div className="swatch" style={{backgroundColor: '#2D4A7F'}}>#2D4A7F</div>
             <div className="swatch" style={{backgroundColor: '#808A9F'}}>#808A9F</div>
             <div className="swatch" style={{backgroundColor: '#B3B3B3'}}>#B3B3B3</div>
          </div>
        </div>
      </section>

      {/* 6. Design Process */}
      <section className="circa-process-section">
        <div className="process-header">
          <h2>{t.processTitle}</h2>
          <p className="process-intro-text">
            {t.processIntro}
          </p>
        </div>
        <div className="circa-process-grid">
          {/* Card 1: Understanding */}
          {t.processCards && t.processCards[0] && (
            <div className="process-col process-col-white">
              <h3>{t.processCards[0].title}</h3>
              <p className="process-subtitle">{t.processCards[0].subtitle}</p>
              <div className="process-text" dangerouslySetInnerHTML={{ __html: t.processCards[0].text }} />
              <div className="process-tags">
                 {t.processCards[0].tags.map((tag, i) => (
                   <span key={i} style={{transform: `rotate(${i % 2 === 0 ? -2 : 3}deg)`}}>{tag}</span>
                 ))}
              </div>
            </div>
          )}

          {/* Card 2: Research */}
          {t.processCards && t.processCards[1] && (
            <div className="process-col process-col-white">
              <h3>{t.processCards[1].title}</h3>
              <p className="process-subtitle">{t.processCards[1].subtitle}</p>
              <div className="process-text" dangerouslySetInnerHTML={{ __html: t.processCards[1].text }} />
              <div className="process-tags">
                 {t.processCards[1].tags.map((tag, i) => (
                   <span key={i} style={{transform: `rotate(${i % 2 === 0 ? -5 : 5}deg)`}}>{tag}</span>
                 ))}
              </div>
            </div>
          )}

          {/* Card 3: Design */}
          {t.processCards && t.processCards[2] && (
            <div className="process-col process-col-blue">
              <h3>{t.processCards[2].title}</h3>
              <p className="process-subtitle">{t.processCards[2].subtitle}</p>
              <div className="process-text" dangerouslySetInnerHTML={{ __html: t.processCards[2].text }} />
              <div className="process-tags">
                 {t.processCards[2].tags.map((tag, i) => (
                   <span key={i} style={{transform: `rotate(${i % 2 === 0 ? -3 : 4}deg)`}}>{tag}</span>
                 ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* New Questions Section */}
      <section className="circa-questions-section">
        <div className="questions-bg">
           <img src="/Circa/new/questionss.png" alt="Questions Background" />
        </div>
        <div className="questions-overlay">
           <img src="/Circa/new/mainQuestion.png" alt="Main Question Interaction" />
        </div>
      </section>

      {/* 7. Assets Showcase */}
      <section className="circa-assets-section">
        <div className="assets-row-1">
           <img src="/Circa/new/app-icon-preview.png" alt="App Icon Design 1" />
           <img src="/Circa/new/app-icon2-preview.png" alt="App Icon Design 2" />
        </div>
        <div className="assets-row-2">
           <img src="/Circa/new/app-store-preview.png" alt="App Store Preview" />
        </div>
      </section>

      {/* 9. Mockups */}
      <section className="circa-mockups-section">
        <h2>{t.mockupsTitle}</h2>
        <p className="mockups-intro">{t.mockupsIntro}</p>
        <div className="mockups-display">
           <img src="/Circa/new/mockups.png" alt="Circa Mockups" className="circa-mockups-image" />
        </div>
      </section>

      {/* 10. Outro / Footer */}
      <section className="circa-outro-section">
         <div className="outro-content">
            <div className="outro-graphic">
               {/* Brain Graphic Placeholder */}
               <div className="brain-placeholder">
                  <span>🧠</span>
                  <span className="brain-text">CIRCA</span>
               </div>
            </div>
            <div className="outro-text">
               <h3 dangerouslySetInnerHTML={{ __html: t.outroText }} />
            </div>
         </div>
      </section>

      <Footer />
    </div>
  );
}

export default Circa;
